import BaseAPIService from "./BaseAPIService";

export default class PlatformService extends BaseAPIService {
  constructor() {
    super();
  }

  async getPlatformContentApproval(id) {
    const query = require("../graphql/queries/platformContentApproval.gql");
    const variables = { id };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.platformContentApproval;
  }

  async getPlatformContentApprovalByContentId(contentId) {
    const query = require("../graphql/queries/platformContentApprovalByContentId.gql");
    const variables = { contentId };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.platformContentApprovalByContentId;
  }

  async updatePlatformContentApprovalStatus(id, status) {
    const mutation = require("../graphql/mutations/updatePlatformContentApprovalStatus.gql");
    const variables = { id, status };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.updatePlatformContentApprovalStatus;
  }

  async getJoinablePlatforms(variables) {
    const query = require("../graphql/queries/joinablePlatforms.gql");
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.joinablePlatforms;
  }

  async getPlatformById(id) {
    const query = require("../graphql/queries/platform.gql");
    const variables = { id };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.platform;
  }

  async requestPlatformContentApproval(variables) {
    const mutation = require("../graphql/mutations/requestPlatformContentApproval.gql");
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.requestPlatformContentApproval;
  }
}
